import { Component, OnInit } from '@angular/core';
import { SecurityService } from 'src/app/services/security.service';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'unauthorized',
    templateUrl: './unauthorized.component.html',
    standalone: false
})
export class UnauthorizedComponent implements OnInit {

    constructor(private securityService: SecurityService) { }

    ngOnInit() {
    }

    logout() {
        this.securityService.logout();
    }
}
